import { FiltersFeature } from 'features/Filters'
import { GamesFeature } from 'features/Games'
import { InitFeature } from 'features/Init'
import { LayoutFeature } from 'features/Layout'
import { IFeature } from 'types'

export const appFeatures: IFeature[] = [InitFeature, LayoutFeature, FiltersFeature, GamesFeature]
